__turbopack_context__.v({
  "Links": "DmgWsa_Links",
  "Title": "DmgWsa_Title",
  "Wrapper": "DmgWsa_Wrapper",
  "WrapperLarge": "DmgWsa_WrapperLarge",
});
